import { Component } from '@angular/core';
import { ConfigService } from 'app/_services/config.service';

@Component({
    selector: 'app-calendar-widget',
    template: '<full-calendar-widget api="{{apiUrl}}"></full-calendar-widget>',
})
export class CalendarWidgetComponent {
    apiUrl = '';

    constructor(private configService: ConfigService) {
        this.apiUrl = this.configService.hostAddress;
    }
}
